(function($) {
	// REF tuto
	// https://www.w3schools.com/howto/howto_js_autocomplete.asp

	'use strict';

	var config = {
		currentFocus: -1,
		xhr: null,
	};

	var init = function() {

		var searchInputs = $('form.main-search .search__input');

		// Listen input
		searchInputs.on("input", debounce(search, 200));

		// Listen keydown
		searchInputs.on("keydown", selectDown);

		// execute a function when someone clicks in the document:
		$(document).on("click", closeAllLists);
	};

	function selectDown(e) {
		var x = document.getElementById(this.id + "autocomplete-list");
		if (x) x = x.getElementsByClassName("autocomplete__item");

		if (e.keyCode == 40) {
			// If the arrow DOWN key is pressed,
			// increase the currentFocus variable:
			config.currentFocus++;
			// and and make the current item more visible:
			addActive(x);
		} else if (e.keyCode == 38) { //up
			// If the arrow UP key is pressed,
			// decrease the currentFocus variable:
			config.currentFocus--;
			// and and make the current item more visible:
			addActive(x);
		} else if (e.keyCode == 13 && config.currentFocus > -1) {
			// If the ENTER key is pressed, prevent the form from being submitted,
			e.preventDefault();
			// and simulate a click on the "active" item:
			if (x) x[config.currentFocus].click();
		}
		
	}

	var successfulRequests = 0;
	var doneRequests = 0;

	var search = function(e) {
		var currentInput = $(e.currentTarget),
			query = currentInput.val();

		closeAllLists();

		if(!query || query.length < 3) {
			return false;
		}

  		if (!!config.xhr) {
  			config.xhr.abort();
  		}
		
		config.xhr = $.ajax({
			url: MyAjax.ajaxurl,
			method: 'POST',
			data: {
				action: 'search_autocompletion',
				search: query
			},
		})
		.done(function(res) {
			if(res.content) {
				currentInput.parent().append(res.content);
			}
		})
	}

	var closeAllLists = function () {
		// close all autocomplete lists in the document,
		// except the one passed as an argument:
		var autocompleteItems = $('#autocomplete-list');
		autocompleteItems.remove();
	}

	var addActive = function(x) {
		// a function to classify an item as "active":
		if (!x) return false;
		// start by removing the "active" class on all items:
		removeActive(x);
		if (config.currentFocus >= x.length) config.currentFocus = 0;
		if (config.currentFocus < 0) config.currentFocus = (x.length - 1);
		// add class "autocomplete-active":
		x[config.currentFocus].classList.add("autocomplete__active");
	};

	var removeActive = function(x) {
		// a function to remove the "active" class from all autocomplete items:
		for (var i = 0; i < x.length; i++) {
			x[i].classList.remove("autocomplete__active");
		}
	};

	var debounce = function(func, wait, immediate) {
        var timeout;
        return function() {
            var context = this, args = arguments;
            var later = function() {
                timeout = null;
                if (!immediate) func.apply(context, args);
            };
        
            var callNow = immediate && !timeout;
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
            if (callNow) func.apply(context, args);
        };
    };

	$(document).ready(function() {
		init();
	});

})(jQuery);
